import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '@/context/LanguageContext';
import { Building2, Store } from 'lucide-react';

export default function ClientsLayout() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    {
      id: 'wholesale',
      path: '/clients/wholesale',
      label: t('nav.clients_wholesale') || 'Оптовые клиенты',
      icon: <Building2 className="w-4 h-4 mr-2" />,
    },
    {
      id: 'retail',
      path: '/clients/retail',
      label: t('nav.clients_retail') || 'Розничные клиенты',
      icon: <Store className="w-4 h-4 mr-2" />,
    },
  ];

  // Auto-redirect from base /clients to /clients/wholesale
  useEffect(() => {
    if (location.pathname === '/clients' || location.pathname === '/clients/') {
      navigate('/clients/wholesale', { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <div className="flex flex-col h-full animate-in fade-in duration-500">
      <div className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800 px-6 py-2 sticky top-0 z-10">
        <div className="flex items-center gap-1 overflow-x-auto scrollbar-none">
          {tabs.map((tab) => {
            const isActive = location.pathname.startsWith(tab.path);
            return (
              <button
                key={tab.id}
                onClick={() => navigate(tab.path)}
                className={`
                  flex items-center px-4 py-2 text-sm font-medium rounded-sm whitespace-nowrap transition-all duration-200
                  ${
                    isActive
                      ? 'bg-blue-50 text-blue-700 dark:bg-blue-500/10 dark:text-blue-400 shadow-xs ring-1 ring-blue-500/20'
                      : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-200'
                  }
                `}
              >
                {React.cloneElement(tab.icon, {
                  className: `w-4 h-4 mr-2 ${isActive ? 'text-blue-500' : 'text-slate-400'}`,
                })}
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>
      <div className="flex-1 overflow-auto bg-slate-50 dark:bg-[#020617] p-6">
        <Outlet />
      </div>
    </div>
  );
}
